"use client"

import { AlertCircle, Mail, MessageSquare } from "lucide-react"
import { Button } from "../../ui/button"
import { FeedbackModal } from "../../modals/feedback-modal"
import { useState } from "react"

export default function NoRoleAssignedPage() {
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false)

  const openFeedbackModal = () => setIsFeedbackModalOpen(true)
  const closeFeedbackModal = () => setIsFeedbackModalOpen(false)

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 p-4">
      <div className="max-w-2xl w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="flex justify-center mb-6">
          <div className="rounded-full bg-orange-100 p-4">
            <AlertCircle className="h-12 w-12 text-orange-600" />
          </div>
        </div>
        
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          No Role Assigned
        </h1>
        
        <p className="text-lg text-gray-600 mb-6">
          You don't have any roles assigned to your account yet.
        </p>
        
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-6">
          <p className="text-gray-700 mb-4">
            To get access to the system, please contact your administrator or submit a request using the feedback form below.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button
              onClick={openFeedbackModal}
              className="bg-blue-600 hover:bg-blue-700 text-white flex items-center gap-2"
            >
              <MessageSquare className="h-4 w-4" />
              Open Feedback Form
            </Button>
            
            <Button
              variant="outline"
              onClick={() => window.location.href = "mailto:rutang@uciny.com?cc=paritosh@uciny.com"}
              className="flex items-center gap-2"
            >
              <Mail className="h-4 w-4" />
              Contact HR
            </Button>
          </div>
        </div>

        
      </div>

      {/* Feedback Modal */}
      <FeedbackModal
        isOpen={isFeedbackModalOpen}
        onClose={closeFeedbackModal}
      />
    </div>
  )
}

